var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStudentGoingToSchool(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 960,
    height: 960,
    viewBox: "0 0 960 960",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_46_7733)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_46_7733)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M863.249 765.143C867.064 760.513 870.868 754.513 868.718 748.913C866.781 743.869 860.508 741.636 855.169 742.522C849.83 743.408 845.224 746.645 840.83 749.787C794.838 782.671 748.849 815.556 702.864 848.441L702.876 848.453C708.741 849.205 714.14 852.038 718.09 856.438C722.041 860.837 724.279 866.508 724.398 872.42L725.047 873.436C749.869 857.58 774.127 840.929 797.822 823.483C821.41 806.119 844.633 787.774 863.249 765.143ZM847.64 771C848.342 770.318 848.358 769.196 847.675 768.494C846.993 767.793 845.871 767.777 845.17 768.459C816.012 796.804 783.736 821.754 748.96 842.831C748.124 843.338 747.856 844.428 748.364 845.265C748.871 846.102 749.96 846.369 750.797 845.862C785.802 824.646 818.291 799.532 847.64 771Z",
    fill: "url(#paint0_linear_46_7733)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M431.044 441.596C432.459 441.664 433.877 441.545 435.261 441.242C435.98 441.074 436.661 440.774 437.271 440.358C440.484 438.133 440.271 433.432 439.811 429.558C439.232 424.656 438.818 419.742 438.57 414.816C438.071 405.136 438.205 395.433 438.97 385.77C439.909 373.653 441.812 361.629 444.663 349.814C446.376 342.714 448.42 335.714 450.794 328.814L451.881 329.204L474.56 331.661L474.607 331.248C479.918 301.157 474.942 270.154 460.48 243.236C445.266 253.406 431.032 264.722 419.244 278.329C407.884 291.354 399.22 306.502 393.753 322.896C391.212 330.322 389.175 337.911 387.658 345.611C386.705 350.411 385.922 355.226 385.308 360.057C382.367 382.961 382.863 406.16 383.678 429.241C383.808 432.962 384.197 437.194 387.127 439.494C387.66 439.913 388.253 440.247 388.887 440.486C390.926 441.161 393.072 441.453 395.218 441.348L431.044 441.596ZM459.058 290.825C459.549 289.978 459.261 288.894 458.414 288.403C457.568 287.912 456.483 288.2 455.992 289.047C434.039 326.902 422.613 369.941 422.901 413.7C422.908 414.679 423.706 415.467 424.685 415.461C425.664 415.454 426.452 414.656 426.445 413.677C426.161 370.55 437.422 328.132 459.058 290.825Z",
    fill: "url(#paint1_linear_46_7733)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M556.453 299.344C555.745 294.844 555.107 290.332 554.54 285.807L555.113 285.743C579.021 297.177 605.456 302.149 631.703 298.523C657.95 294.897 683.168 282.069 700.119 261.705C717.116 241.279 725.007 214.914 731.291 189.105C732.118 185.727 732.803 181.793 730.641 179.065C728.893 176.867 725.869 176.253 723.093 175.793C722.266 175.651 721.435 175.51 720.605 175.369C720.047 175.274 719.49 175.179 718.935 175.084C708.552 173.32 698.17 171.564 687.787 169.816C687.737 169.807 687.688 169.799 687.638 169.79C687.348 169.74 687.064 169.691 686.771 169.65C685.535 169.403 684.26 169.436 683.039 169.745C678.155 171.221 678.172 177.978 678.455 183.069C679.731 206.221 664.766 228.384 644.484 239.602C624.202 250.82 599.586 252.226 576.848 247.702C571.22 246.577 565.66 245.138 560.193 243.39C556.716 242.291 553.283 241.087 549.893 239.776C545.849 259.815 547.976 280.609 555.993 299.415L556.453 299.344ZM719.936 193.615C720.015 192.639 719.288 191.785 718.313 191.705C717.337 191.626 716.483 192.353 716.403 193.328C713.489 229.267 691.037 263.053 659.032 279.661C658.164 280.112 657.825 281.181 658.276 282.05C658.727 282.919 659.796 283.257 660.665 282.807C693.753 265.636 716.922 230.77 719.936 193.615Z",
    fill: "url(#paint2_linear_46_7733)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M531.234 203.146C553.252 197.477 570.12 176.639 572.258 154.007C574.384 131.387 562.305 108.307 543.146 96.0935C523.987 83.8805 498.686 82.5105 477.778 91.4165C456.87 100.323 440.605 118.927 433.329 140.461C431.919 144.636 430.744 149.036 429.564 153.453C425.735 167.793 421.857 182.314 409.729 189.918C400.354 195.798 389.162 195.443 377.821 195.083C369.685 194.825 361.472 194.565 353.799 196.603C333.789 201.919 321.139 221.822 314.772 241.513C312.385 248.896 310.582 256.483 308.781 264.063C305.779 276.699 302.781 289.314 297.089 300.928C287.982 319.508 268.799 335.667 248.399 332.183L245.872 333.01C251.56 338.638 258.425 342.935 265.974 345.591C273.522 348.247 281.566 349.196 289.525 348.369C297.485 347.542 305.161 344.96 312.003 340.809C318.844 336.657 324.679 331.04 329.088 324.363C335.957 313.967 338.934 301.763 341.914 289.552C343.091 284.724 344.269 279.896 345.688 275.178C350.696 258.523 360.926 241.171 377.864 237.261C385.526 235.488 393.353 236.764 401.212 238.045C407.916 239.138 414.642 240.234 421.309 239.446C431.059 238.283 439.685 233.247 448.308 228.214C457.037 223.118 465.763 218.025 475.645 216.956C476.447 216.869 477.258 216.808 478.07 216.747C480.922 216.533 483.787 216.317 486.287 214.995C490.894 212.549 492.571 207.505 492.571 202.095C492.53 198.72 491.981 195.371 490.941 192.16C490.651 191.253 490.347 190.334 490.039 189.408C487.618 182.11 485.035 174.326 488.441 167.639L488.264 166.493C501.759 164.313 514.428 158.572 524.964 149.862C528.318 147.102 531.421 144.05 534.237 140.743L536.337 140.849C546 159.194 544.452 182.899 532.487 199.826C531.837 200.748 531.167 201.634 530.467 202.52L531.234 203.146ZM520.237 90.6271C519.282 90.4112 518.333 91.01 518.117 91.9646C517.901 92.9191 518.5 93.8679 519.455 94.0838C526.75 95.7337 533.638 98.8349 539.71 103.203C545.781 107.571 550.912 113.116 554.795 119.508C558.679 125.9 561.236 133.008 562.315 140.409C563.394 147.811 562.972 155.353 561.075 162.588C560.826 163.535 561.393 164.503 562.339 164.752C563.286 165 564.254 164.434 564.503 163.487C566.521 155.792 566.969 147.77 565.822 139.898C564.675 132.027 561.955 124.466 557.824 117.668C553.694 110.869 548.237 104.971 541.78 100.326C535.322 95.6803 527.996 92.3819 520.237 90.6271Z",
    fill: "#171717"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M669.448 907.099C665.077 909.615 660.686 912.1 656.277 914.553C649.072 918.569 634.519 924.747 629.677 913.844C625.012 903.32 640.663 892.925 647.608 887.952C666.023 874.782 684.442 861.612 702.865 848.441L702.877 848.452C708.742 849.204 714.141 852.038 718.092 856.437C722.042 860.836 724.281 866.508 724.4 872.419L725.049 873.435C706.786 885.117 688.253 896.339 669.448 907.099Z",
    fill: "url(#paint3_linear_46_7733)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M549.142 802.918C548.397 810.336 547.652 817.754 546.909 825.172C546.924 826.058 546.623 826.921 546.059 827.605C545.173 828.42 543.791 828.196 542.633 827.912L530.124 824.935C529.498 824.782 529.486 824.593 529.25 823.99C529.25 823.955 529.262 823.908 529.262 823.872C530.006 817.139 530.695 810.398 531.329 803.65C531.979 796.964 532.566 790.274 533.089 783.581L533.597 783.617C545.214 785.469 556.978 786.239 568.738 785.917C576.311 803.98 589.625 819.045 606.619 828.783C595.256 829.244 583.609 829.657 572.813 826.114C562.017 822.571 552.047 814.187 549.98 803L549.142 802.918Z",
    fill: "#171717"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M564.674 340.368L564.037 340.521C551.398 326.795 544.263 308.711 540.826 290.355C539.279 281.732 538.308 273.015 537.92 264.262C537.42 254.387 537.436 244.462 537.447 234.578C541.57 236.445 545.704 238.178 549.897 239.778C545.852 259.817 547.978 280.611 555.992 299.417L556.453 299.346C558.603 313.13 561.343 326.804 564.674 340.368Z",
    fill: "#171717"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M537.92 264.261L535.62 264.367C534.675 250.831 529.277 237.885 520.465 226.746L520.595 226.486C526.205 229.333 531.804 232.061 537.451 234.577C537.436 244.464 537.424 254.386 537.92 264.261Z",
    fill: "url(#paint4_linear_46_7733)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M535.616 264.369C536.051 270.598 535.525 276.856 534.056 282.925L533.584 283.032C531.54 273.05 526.001 264.924 516.598 260.932L516.137 260.483C518.275 258.145 518.837 254.4 518.913 251.069C519.285 241.367 517.426 231.709 513.48 222.838C515.854 224.067 518.225 225.284 520.591 226.488L520.461 226.748C529.273 237.886 534.671 250.832 535.616 264.369Z",
    fill: "url(#paint5_linear_46_7733)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M531.093 803.625L531.329 803.649C530.703 810.394 530.014 817.135 529.262 823.871L528.317 823.777C516.552 796.951 495.054 775.572 468.831 762.519C442.689 749.615 412.914 746.059 384.469 752.444C389.489 748.628 394.525 744.828 399.577 741.044C400.014 740.713 400.463 740.382 400.9 740.052C426.638 733.803 454.468 738.918 478.281 750.505C502.2 762.141 520.143 779.387 531.093 803.625Z",
    fill: "#171717"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M533.585 283.031L534.057 282.924C535.525 276.856 536.051 270.597 535.617 264.368L537.917 264.261C538.305 273.014 539.276 281.731 540.823 290.354C544.26 308.71 551.395 326.794 564.034 340.52L564.671 340.367C569.802 361.203 576.309 381.674 584.15 401.648C585.071 404.01 585.969 406.833 584.528 408.912C583.134 410.912 580.328 411.121 577.889 411.133L574.389 411.168C557.935 411.381 538.279 412.019 522.333 412.161L522.073 412.101C528.239 384.355 534.003 358.38 534.003 358.38L528.924 357.896L528.995 357.128L531.924 341.713L531.133 341.666L525.533 341.347L525.627 339.764C526.411 313.245 523.271 286.756 516.308 261.155L515.599 261.001C515.785 260.837 515.962 260.664 516.131 260.481L516.591 260.93C526 264.923 531.541 273.049 533.585 283.031Z",
    fill: "url(#paint6_linear_46_7733)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M516.316 261.156C523.279 286.756 526.42 313.246 525.635 339.765L525.541 341.348L517.331 340.876L516.575 340.746L517.331 336.292L484.966 332.784L485.132 331.249C487.697 299.349 482.438 267.306 469.811 237.9L469.493 237.392C477.537 232.348 485.758 227.54 493.955 222.839C489.467 230.619 484.144 237.887 478.08 244.514C492.597 255.89 501.728 270.17 506.5 287.983L506.583 288.007C509.488 279.23 512.398 270.458 515.312 261.689L515.087 261.418C515.268 261.289 515.442 261.151 515.607 261.004L516.316 261.156Z",
    fill: "url(#paint7_linear_46_7733)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M549.9 239.775C545.707 238.18 541.573 236.444 537.451 234.575C531.804 232.059 526.205 229.331 520.595 226.484C518.232 225.28 515.862 224.063 513.484 222.834L513.384 222.763C514.508 221.069 515.719 219.434 517.011 217.863C517.353 217.438 517.696 217.025 518.062 216.611L518.215 216.741C528.008 217.249 536.926 217.792 546.706 218.289C550.167 218.466 553.982 218.796 556.392 221.277C558.601 223.557 558.992 226.994 559.263 230.16C559.629 234.4 559.995 238.649 560.363 242.905L560.198 243.389C556.725 242.291 553.293 241.087 549.9 239.775Z",
    fill: "#171717"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M514.39 261.864C514.635 261.733 514.869 261.583 515.09 261.415L515.315 261.687C512.409 270.464 509.499 279.236 506.586 288.005L506.503 287.981C501.731 270.168 492.603 255.887 478.083 244.512C484.147 237.885 489.47 230.617 493.958 222.837L494.1 222.589C495.008 232.23 496.911 241.751 499.779 251C500.879 254.308 502.247 257.662 504.787 260.036C507.327 262.41 511.343 263.542 514.39 261.864Z",
    fill: "url(#paint8_linear_46_7733)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M460.48 243.237C445.266 253.407 431.032 264.723 419.244 278.33C418.869 273.246 418.944 268.139 419.468 263.069C420.002 257.913 421.916 252.996 425.008 248.836C428.682 244.205 434.056 241.299 439.372 238.748C457.113 230.248 474.772 224.668 493.518 218.727L493.707 218.715C493.825 220.002 493.955 221.302 494.097 222.589L493.955 222.837C485.755 227.537 477.537 232.346 469.493 237.39C466.457 239.3 463.445 241.24 460.48 243.237Z",
    fill: "#171717"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M469.81 237.9C482.437 267.306 487.697 299.351 485.131 331.251L484.965 332.786L474.559 331.664L474.606 331.251C479.918 301.159 474.942 270.156 460.479 243.239C463.444 241.239 466.456 239.305 469.492 237.392L469.81 237.9Z",
    fill: "#171717"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.579 753.7C347.71 719.126 297.367 700.781 248.429 704.821L248.157 704.49C256.839 697.498 265.923 690.08 275.597 682.036C321.667 688.774 364.677 709.113 399.116 740.446L399.577 741.046C394.533 744.826 389.497 748.626 384.469 752.446C383.869 752.906 383.269 753.355 382.662 753.816L382.579 753.7Z",
    fill: "#171717"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.981 549.016L303.922 549.027C291.599 552.714 278.893 554.969 266.053 555.748C262.026 548.395 256.278 542.127 249.301 537.481C242.323 532.834 234.323 529.946 225.986 529.065C239.31 527.388 251.772 518.665 265.06 520.607C274.805 522.013 282.743 528.9 290.079 535.479C288.897 527.565 287.712 519.659 286.523 511.76C291.429 510.973 296.261 509.78 300.969 508.193L301.669 508.217C301.116 521.86 301.89 535.524 303.981 549.016V549.016Z",
    fill: "#171717"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.277 819.844L140.455 820.044C188.212 817.782 236.055 822.047 282.66 832.72C282.79 832.578 282.92 832.436 283.06 832.306C283.332 832.554 283.603 832.814 283.86 833.074L284.026 833.499C318.819 820.175 357.34 820.365 392 834.031C431.972 850.001 462.719 883.772 505.136 891.071L505.936 890.918C507.861 889.867 509.786 888.803 511.712 887.752L511.747 887.41C514.6 887.754 517.475 887.872 520.347 887.764C528.687 883.323 537.023 878.877 545.354 874.428L545.377 873.849C552.402 874.24 559.447 873.579 566.277 871.889L566.69 872.172C618.39 821.817 687.138 791.972 743.577 747.578L778.859 756.106L562.076 918.416L282.483 838.933L90.7139 832.814L152 789.735L151.965 789.594C156.134 788.725 160.381 788.286 164.639 788.283V788.625C157.882 796.256 139.845 807.347 133.077 814.978C137.731 814.434 142.401 814.001 147.086 813.678L147.098 813.807C144.815 815.816 142.541 817.828 140.277 819.844Z",
    fill: "url(#paint9_linear_46_7733)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M507.374 239.138C507.657 233.244 510.091 227.727 513.374 222.766H513.386C514.511 221.071 515.721 219.436 517.013 217.866C517.355 217.441 517.698 217.028 518.064 216.614C522.092 211.83 526.592 207.414 530.464 202.522C531.164 201.636 531.834 200.751 532.484 199.829C544.449 182.902 545.997 159.196 536.334 140.851",
    stroke: "#171717",
    strokeWidth: 3.544,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M473.98 167.285C478.755 167.512 483.541 167.247 488.261 166.493C501.757 164.313 514.426 158.572 524.961 149.862C528.316 147.102 531.419 144.05 534.234 140.743C537.481 136.956 540.308 132.829 542.668 128.435",
    stroke: "#171717",
    strokeWidth: 3.544,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M531.234 203.146C553.252 197.477 570.12 176.64 572.258 154.008C574.396 131.376 562.324 108.308 543.153 96.0926C523.982 83.8776 498.692 82.5086 477.785 91.4156C456.878 100.323 440.612 118.926 433.336 140.46C427.347 158.19 425.599 179.971 409.736 189.917C393.636 200.017 372.174 191.724 353.806 196.602C333.796 201.918 321.157 221.821 314.779 241.512C308.401 261.203 306.215 282.335 297.096 300.927C287.977 319.519 268.806 335.666 248.406 332.182",
    stroke: "#171717",
    strokeWidth: 3.544,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.921 332.04C245.24 332.371 245.559 332.69 245.878 333.009C251.566 338.638 258.431 342.935 265.98 345.591C273.528 348.247 281.572 349.195 289.531 348.368C297.49 347.541 305.167 344.959 312.008 340.808C318.85 336.657 324.685 331.04 329.094 324.362C338.673 309.862 340.694 291.832 345.694 275.177C350.694 258.522 360.931 241.17 377.87 237.26C392.07 233.976 406.833 241.16 421.315 239.445C440.935 237.106 456.007 219.081 475.651 216.955C479.265 216.565 483.08 216.695 486.293 214.994C490.9 212.549 492.577 207.505 492.577 202.094C492.536 198.719 491.987 195.37 490.947 192.16C488.372 184.104 484.604 175.174 488.447 167.638",
    stroke: "#171717",
    strokeWidth: 3.544,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M492.7 202.048V202.095C492.877 207.434 493.185 213.045 493.7 218.715C493.818 220.002 493.948 221.302 494.09 222.589C495.002 232.23 496.908 241.751 499.779 251C500.879 254.308 502.247 257.662 504.787 260.036C507.327 262.41 511.343 263.545 514.387 261.867C514.632 261.736 514.866 261.586 515.087 261.418C515.268 261.29 515.442 261.152 515.607 261.005C515.793 260.841 515.97 260.667 516.138 260.485C518.277 258.146 518.838 254.402 518.914 251.071C519.286 241.369 517.427 231.711 513.481 222.84",
    stroke: "#171717",
    strokeWidth: 3.544,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M513.48 222.837C515.854 224.066 518.225 225.283 520.591 226.487C526.201 229.334 531.8 232.062 537.447 234.578C541.569 236.445 545.703 238.178 549.897 239.778C553.287 241.089 556.721 242.293 560.197 243.392C565.664 245.14 571.225 246.579 576.852 247.704C599.59 252.228 624.206 250.822 644.488 239.604C664.77 228.386 679.735 206.223 678.459 183.071C678.176 177.98 678.159 171.223 683.043 169.747C684.265 169.438 685.54 169.405 686.775 169.652C687.118 169.7 687.448 169.759 687.791 169.818C698.174 171.566 708.557 173.322 718.939 175.086C720.321 175.322 721.715 175.558 723.097 175.795C725.873 176.255 728.897 176.869 730.645 179.067C732.807 181.795 732.122 185.729 731.295 189.107C725.011 214.916 717.12 241.281 700.123 261.707C683.172 282.071 657.954 294.899 631.707 298.525C605.46 302.151 579.025 297.179 555.117 285.745",
    stroke: "#171717",
    strokeWidth: 3.544,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M554.481 285.358C554.504 285.511 554.516 285.658 554.54 285.806C555.107 290.331 555.745 294.843 556.453 299.343C558.603 313.129 561.343 326.803 564.674 340.367C569.805 361.202 576.313 381.674 584.153 401.648C585.074 404.01 585.972 406.833 584.531 408.912C583.137 410.912 580.325 411.121 577.892 411.133L574.392 411.168C557.937 411.381 538.282 412.019 522.336 412.161",
    stroke: "#171717",
    strokeWidth: 3.544,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M494.038 222.79C494.014 222.802 493.979 222.825 493.955 222.837C485.755 227.537 477.537 232.346 469.493 237.39C466.457 239.303 463.445 241.24 460.48 243.237C445.266 253.407 431.032 264.723 419.244 278.33C407.884 291.355 399.22 306.504 393.753 322.9C391.212 330.325 389.176 337.914 387.658 345.614C386.701 350.41 385.918 355.225 385.308 360.06C382.366 382.96 382.863 406.16 383.678 429.244C383.808 432.965 384.197 437.193 387.127 439.497C387.66 439.915 388.253 440.25 388.887 440.489C390.926 441.164 393.073 441.456 395.218 441.351L431.044 441.599C432.459 441.666 433.877 441.547 435.261 441.245C435.979 441.076 436.66 440.775 437.269 440.359C440.482 438.138 440.269 433.437 439.809 429.559C439.23 424.657 438.817 419.743 438.568 414.817C438.069 405.137 438.203 395.434 438.968 385.771C439.907 373.653 441.811 361.63 444.661 349.815C446.362 342.716 448.405 335.716 450.792 328.815C455.654 314.683 461.914 301.071 469.479 288.182",
    stroke: "#171717",
    strokeWidth: 3.544,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M446.045 468.3L446.636 468.407C473.379 473.037 489.987 475.848 498.928 477.183C504.657 478.034 507.244 478.293 507.328 478.034C507.552 477.372 515.076 443.601 522.081 412.098C528.247 384.352 534.011 358.377 534.011 358.377L528.932 357.893L526.073 357.621L513.942 356.463L445.078 349.908",
    stroke: "#171717",
    strokeWidth: 3.544,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.843 345.459L376.012 344.207L347.556 426.029L339.323 449.689C339.323 449.689 348.823 451.496 388.095 458.3",
    stroke: "#171717",
    strokeWidth: 3.544,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M498.987 476.786L526.072 357.625L526.084 357.554",
    stroke: "#171717",
    strokeWidth: 3.544,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M529.002 357.129L531.931 341.714L531.14 341.667L525.541 341.348L517.332 340.875",
    stroke: "#171717",
    strokeWidth: 3.544,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M514 355.889L516.233 342.777L516.576 340.746L517.332 336.292L484.966 332.784L474.56 331.662L451.881 329.205",
    stroke: "#171717",
    strokeWidth: 3.544,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.678 322.53L379.343 321.692L341.402 425.083L347.237 425.922",
    stroke: "#171717",
    strokeWidth: 3.544,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M517.308 342.199C517.214 342.436 517.147 342.681 517.108 342.932C516.964 344.032 517.172 345.149 517.703 346.124C518.233 347.098 519.059 347.879 520.061 348.354C521.208 348.827 522.458 348.992 523.688 348.835C524.918 348.677 526.086 348.201 527.077 347.454C528.987 345.982 530.404 343.963 531.141 341.666C531.173 341.593 531.201 341.518 531.224 341.441",
    stroke: "#171717",
    strokeWidth: 3.544,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M438.958 414.8C443.423 414.93 447.569 411.752 449.424 407.677C451.279 403.602 451.113 398.853 449.884 394.554C449.264 392.015 447.981 389.687 446.164 387.809C445.243 386.884 444.1 386.212 442.845 385.856C441.589 385.5 440.263 385.473 438.994 385.777",
    stroke: "#171717",
    strokeWidth: 3.544,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M574.4 411.335C586.048 436.268 597.69 461.204 609.328 486.141C609.895 487.341 610.462 488.741 609.928 489.956C609.207 491.622 606.998 491.87 605.179 491.881C599.462 491.929 593.753 492.071 588.052 492.307C567.333 493.145 546.674 495.094 526.062 497.445C520.404 498.071 514.762 498.745 509.111 499.429C504.057 500.044 499.005 500.663 493.956 501.284C479.912 503.008 465.864 504.736 451.811 506.469C443.448 507.497 435.089 508.525 426.734 509.552C427.893 498.21 430.484 487.062 434.447 476.372",
    stroke: "#171717",
    strokeWidth: 3.544,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.981 440.108C388.946 440.238 388.91 440.356 388.887 440.486C387.347 446.278 387.226 452.356 388.532 458.204C389.527 462.792 391.392 467.146 394.025 471.032C396.525 474.717 400.002 478.107 404.384 478.932C408.766 479.757 413.964 475.873 414.507 471.455C415.334 475.155 418.464 479.405 422.185 480.161C425.906 480.917 432.568 479.346 430.832 470.877C431.488 473.01 432.773 474.895 434.517 476.286C436.211 477.854 438.296 478.936 440.553 479.417C443.953 479.866 448.703 479.44 449.483 476.109C450.144 473.333 448.514 470.676 446.636 468.409C446.305 468.009 445.963 467.617 445.636 467.239C443.51 464.853 441.384 462.463 439.258 460.069C436.966 457.506 434.682 454.943 432.407 452.38",
    stroke: "#171717",
    strokeWidth: 3.544,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M434.765 440.971C434.93 441.054 435.096 441.148 435.265 441.243C442.034 444.955 448.035 449.921 452.948 455.878C453.964 457.118 454.979 458.843 454.141 460.213C453.341 461.548 451.448 461.513 449.9 461.324C446.38 460.874 442.86 460.433 439.34 460.001",
    stroke: "#171717",
    strokeWidth: 3.544,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.678 507.969C301.678 508.052 301.666 508.135 301.666 508.218C300.616 534.112 304.357 559.977 312.7 584.512C316.822 596.612 322.126 608.443 329.851 618.637C332.611 622.292 335.704 625.685 339.088 628.772C345.105 634.392 352.225 638.7 359.995 641.423C380.371 648.323 403.83 641.659 420.072 627.543C428.7 619.888 435.701 610.577 440.66 600.163C445.017 591.133 448.197 581.582 450.122 571.743C454.339 550.643 453.583 528.877 451.929 507.426",
    stroke: "#171717",
    strokeWidth: 3.544,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.438 556.281C270.162 586.781 281.208 616.806 300.757 640.702C303.974 644.635 307.425 648.37 311.092 651.888C329.755 669.842 353.958 682.198 379.697 684.088C406.109 686.013 432.887 676.741 453.452 660.05C466.358 649.433 476.951 636.284 484.577 621.413C489.101 612.687 492.65 603.489 495.16 593.985C503.311 563.132 500.746 530.224 509.109 499.429C509.133 499.358 509.146 499.276 509.169 499.205",
    stroke: "#171717",
    strokeWidth: 3.544,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.299 556.209L266.051 555.748C262.024 548.395 256.276 542.127 249.299 537.481C242.321 532.834 234.321 529.946 225.984 529.065C239.308 527.388 251.77 518.665 265.058 520.607C274.803 522.013 282.741 528.9 290.077 535.479C288.895 527.565 287.71 519.659 286.521 511.76C291.427 510.973 296.259 509.78 300.967 508.193",
    stroke: "#171717",
    strokeWidth: 3.544,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M525.99 496.865C526.013 497.054 526.037 497.255 526.061 497.444C532.411 546.208 536.116 595.28 537.161 644.444C538.172 690.862 536.812 737.301 533.086 783.579C532.553 790.277 531.966 796.967 531.326 803.648C530.7 810.393 530.011 817.134 529.259 823.87C529.259 823.906 529.247 823.953 529.247 823.988",
    stroke: "#171717",
    strokeWidth: 3.544,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M588 491.811C588.012 491.976 588.036 492.141 588.048 492.311C592.214 536.433 593.2 580.798 591 625.063C588.337 679.174 580.93 732.947 568.864 785.763",
    stroke: "#171717",
    strokeWidth: 3.544,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M568.56 785.5L568.737 785.925C576.311 803.988 589.624 819.053 606.619 828.791C595.256 829.252 583.608 829.665 572.812 826.122C562.017 822.579 552.046 814.186 549.979 803",
    stroke: "#171717",
    strokeWidth: 3.544,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M549.189 802.399C549.177 802.576 549.153 802.741 549.142 802.919C548.397 810.337 547.652 817.755 546.909 825.173C546.924 826.06 546.623 826.922 546.059 827.606C545.173 828.421 543.791 828.197 542.633 827.913L530.124 824.936C529.498 824.783 529.486 824.594 529.25 823.991",
    stroke: "#171717",
    strokeWidth: 3.544,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.1 555.807C265.202 555.806 265.305 555.798 265.407 555.784L266.057 555.748C278.896 554.969 291.602 552.714 303.926 549.027",
    stroke: "#171717",
    strokeWidth: 3.544,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M533.6 783.617C545.217 785.469 556.981 786.239 568.741 785.917H569.036",
    stroke: "#171717",
    strokeWidth: 3.544,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M686.8 169.517C681.969 167.391 676.819 165.005 674.161 160.446C673.299 158.957 672.779 156.997 673.761 155.579C674.148 155.095 674.647 154.714 675.216 154.469C675.784 154.224 676.404 154.122 677.021 154.173C678.254 154.289 679.46 154.608 680.589 155.118C684.416 156.595 688.247 158.08 692.082 159.572",
    stroke: "#171717",
    strokeWidth: 3.544,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M719 174.762C722.537 161.259 724.889 147.473 726.028 133.562C726.257 132.005 726.168 130.418 725.768 128.897C725.552 128.143 725.125 127.466 724.536 126.947C723.948 126.428 723.224 126.088 722.449 125.967C721.767 125.964 721.096 126.134 720.497 126.46C719.898 126.787 719.391 127.259 719.023 127.833C718.297 128.985 717.781 130.257 717.499 131.59C716.814 134.094 716.176 136.61 715.586 139.138C713.979 145.871 712.672 152.671 711.664 159.538",
    stroke: "#171717",
    strokeWidth: 3.544,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M715.432 139.1C715.954 135.447 715.547 131.722 714.251 128.268C714.014 127.438 713.507 126.71 712.81 126.201C712.223 125.943 711.567 125.889 710.946 126.047C710.325 126.205 709.775 126.567 709.384 127.075C708.643 128.124 708.163 129.335 707.984 130.607C707.311 133.702 706.732 136.82 706.271 139.951C705.288 146.43 704.751 152.97 704.665 159.523",
    stroke: "#171717",
    strokeWidth: 3.544,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M706.124 139.928C705.989 135.64 704.938 131.431 703.041 127.584C702.226 125.919 701.033 124.184 699.202 123.899C698.451 123.84 697.699 123.98 697.021 124.306C696.343 124.632 695.763 125.131 695.34 125.754C694.507 127.005 693.949 128.418 693.7 129.9C691.467 139.585 691.845 149.638 692.259 159.56V159.642C692.448 159.465 692.649 159.288 692.85 159.111",
    stroke: "#171717",
    strokeWidth: 3.544,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M533.479 165.962C533.183 165.172 532.707 164.462 532.089 163.888C531.471 163.314 530.728 162.893 529.918 162.657C529.108 162.42 528.255 162.376 527.425 162.528C526.596 162.679 525.813 163.022 525.139 163.529",
    stroke: "#171717",
    strokeWidth: 2.362,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M524.832 149.874C524.879 149.874 524.915 149.862 524.962 149.862C528.349 149.546 531.762 149.657 535.121 150.193",
    stroke: "#171717",
    strokeWidth: 2.362,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M511.225 162.855C511.014 162.216 510.61 161.658 510.068 161.258C509.526 160.859 508.874 160.637 508.201 160.623",
    stroke: "#171717",
    strokeWidth: 2.362,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M518.277 163.812C518.116 166.145 518.522 168.484 519.458 170.628C520.002 171.671 520.46 172.758 520.828 173.876C521.004 174.436 521.041 175.031 520.936 175.609C520.832 176.187 520.589 176.731 520.228 177.195C520.038 177.413 519.803 177.588 519.54 177.708C519.276 177.828 518.991 177.891 518.701 177.892C518.412 177.893 518.125 177.833 517.861 177.715C517.597 177.596 517.361 177.423 517.169 177.207",
    stroke: "#171717",
    strokeWidth: 2.362,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M509.854 191.889C509.283 192.287 508.618 192.531 507.925 192.597C507.232 192.664 506.533 192.55 505.897 192.267C505.301 191.995 504.802 191.55 504.465 190.989C504.127 190.428 503.968 189.778 504.007 189.125",
    stroke: "#171717",
    strokeWidth: 2.362,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M743.498 747.554L743.581 747.578L778.863 756.106L562.076 918.416L282.483 838.933L90.7139 832.814L151.995 789.735",
    stroke: "#171717",
    strokeWidth: 3.544,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M536.751 644.458C528.625 649.821 520.529 655.227 512.465 660.676C474.643 686.238 437.455 712.697 400.9 740.054C400.463 740.384 400.014 740.715 399.577 741.046C394.533 744.826 389.497 748.626 384.469 752.446C383.869 752.906 383.269 753.355 382.662 753.816C356.286 773.896 330.267 794.429 304.607 815.416C298.359 820.531 292.126 825.673 285.907 830.842L284.407 832.095C284.879 831.787 285.364 831.495 285.848 831.195",
    stroke: "#171717",
    strokeWidth: 3.544,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.542 832.849C282.578 832.802 282.625 832.767 282.661 832.72C282.79 832.578 282.92 832.436 283.061 832.306C283.333 831.999 283.616 831.706 283.9 831.406C289.997 825.107 296.971 819.721 304.606 815.413C315.14 809.49 326.541 805.26 338.389 802.88C359.415 798.533 381.208 799.289 402.505 802.053C427.748 805.325 453.581 811.869 473.177 828.111C484.895 837.82 493.86 850.589 506.038 859.72C517.483 868.189 531.166 873.102 545.384 873.847C552.409 874.237 559.454 873.577 566.284 871.887",
    stroke: "#171717",
    strokeWidth: 3.544,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M566.693 872.172C618.393 821.817 687.141 791.972 743.58 747.578C755.649 738.186 767.034 727.947 777.646 716.937",
    stroke: "#171717",
    strokeWidth: 3.544,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M777.2 715.674C754.78 711.894 730.53 707.122 715.446 690.112C706.256 679.753 701.732 666.098 693.724 654.806C682.833 639.438 665.717 629.067 647.444 624.496C629.171 619.925 609.822 620.846 591.466 625.086",
    stroke: "#171717",
    strokeWidth: 3.544,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M511.981 659.956C507.695 644.271 497.986 630.615 484.581 621.413C484.533 621.377 484.498 621.354 484.451 621.312",
    stroke: "#171717",
    strokeWidth: 3.544,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.934 594.115C370.661 608.242 358.352 615.979 339.111 628.748",
    stroke: "#171717",
    strokeWidth: 3.544,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.832 652.16C298.158 663.098 286.51 672.96 275.596 682.033C265.922 690.077 256.839 697.495 248.157 704.487C203.886 740.136 169.843 764.787 120.929 804.311C120.859 804.359 120.792 804.41 120.729 804.465",
    stroke: "#171717",
    strokeWidth: 3.544,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.256 804.737C120.48 804.595 120.705 804.437 120.929 804.311C133.946 795.937 142.852 791.554 151.96 789.594C156.129 788.724 160.375 788.285 164.634 788.282C172.087 788.188 180.675 789.038 192.121 790.182C226.02 793.709 257.804 808.339 282.531 831.796C282.708 831.962 282.885 832.127 283.062 832.304C283.334 832.552 283.606 832.812 283.862 833.072",
    stroke: "#171717",
    strokeWidth: 3.544,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.634 788.625C157.877 796.256 139.84 807.347 133.072 814.978",
    stroke: "#171717",
    strokeWidth: 3.544,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.072 814.978C137.726 814.434 142.396 814.001 147.081 813.678C192.665 810.441 238.424 816.712 281.456 832.093C281.834 832.234 282.212 832.364 282.59 832.506",
    stroke: "#171717",
    strokeWidth: 3.544,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.3 832.14C281.353 832.13 281.404 832.114 281.454 832.093C281.808 831.993 282.174 831.893 282.529 831.793C282.989 831.663 283.438 831.533 283.899 831.403C284.572 831.214 285.234 831.025 285.907 830.836C306.826 824.978 328.029 819.71 349.692 818.186C372.938 816.556 396.964 819.473 417.73 830.069C435.684 839.223 450.33 853.587 466.36 865.812C480.086 876.266 495.087 885.444 511.754 887.405C514.607 887.749 517.482 887.867 520.354 887.759",
    stroke: "#171717",
    strokeWidth: 3.544,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M520.354 887.764C528.694 883.322 537.03 878.877 545.362 874.428",
    stroke: "#171717",
    strokeWidth: 3.544,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.653 833.641C283.783 833.594 283.901 833.546 284.031 833.499C318.824 820.175 357.346 820.364 392.005 834.031C431.977 850.001 462.724 883.772 505.141 891.071",
    stroke: "#171717",
    strokeWidth: 3.544,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M505.945 890.918C507.87 889.867 509.795 888.803 511.721 887.752",
    stroke: "#171717",
    strokeWidth: 3.544,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.334 832.873C283.109 832.826 282.885 832.767 282.66 832.72C236.056 822.047 188.213 817.782 140.455 820.045",
    stroke: "#171717",
    strokeWidth: 3.544,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.018 820.069C140.1 819.986 140.195 819.915 140.277 819.844C142.543 817.824 144.815 815.812 147.093 813.808",
    stroke: "#171717",
    strokeWidth: 3.544,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M494.121 222.554C494.109 222.565 494.109 222.577 494.097 222.589L493.955 222.837C489.467 230.617 484.144 237.885 478.08 244.512",
    stroke: "#171717",
    strokeWidth: 3.544,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M478.08 244.512C492.597 255.887 501.728 270.168 506.5 287.981",
    stroke: "#171717",
    strokeWidth: 3.544,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M506.476 288.335C506.512 288.229 506.547 288.111 506.583 288.005C509.488 279.228 512.398 270.455 515.312 261.687",
    stroke: "#171717",
    strokeWidth: 3.544,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M516.6 260.931C526 264.924 531.542 273.05 533.586 283.031C533.615 283.129 533.638 283.229 533.657 283.331",
    stroke: "#171717",
    strokeWidth: 3.544,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M534.057 282.925C535.525 276.856 536.051 270.598 535.617 264.369C534.672 250.832 529.274 237.886 520.462 226.747",
    stroke: "#171717",
    strokeWidth: 3.544,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M469.811 237.899C482.437 267.306 487.697 299.35 485.132 331.25",
    stroke: "#171717",
    strokeWidth: 3.544,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M474.607 331.248C479.919 301.157 474.942 270.154 460.48 243.236C460.468 243.224 460.468 243.2 460.456 243.188",
    stroke: "#171717",
    strokeWidth: 3.544,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M537.448 234.543V234.578C537.436 244.465 537.424 254.387 537.92 264.262C538.309 273.014 539.279 281.731 540.826 290.355C544.263 308.711 551.398 326.795 564.037 340.521",
    stroke: "#171717",
    strokeWidth: 3.544,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M549.933 239.587C549.921 239.646 549.909 239.717 549.897 239.776C545.852 259.815 547.978 280.609 555.992 299.415",
    stroke: "#171717",
    strokeWidth: 3.544,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M560.363 242.906C559.997 238.654 559.63 234.406 559.263 230.161C558.991 226.995 558.601 223.561 556.392 221.278C553.983 218.797 550.167 218.467 546.706 218.29C536.926 217.79 528.006 217.25 518.215 216.742",
    stroke: "#171717",
    strokeWidth: 3.544,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419.256 278.499C419.258 278.444 419.254 278.388 419.244 278.333C418.869 273.25 418.944 268.143 419.468 263.072C420.002 257.917 421.916 253 425.008 248.839C428.682 244.208 434.056 241.302 439.372 238.751C457.113 230.251 474.772 224.671 493.518 218.73",
    stroke: "#171717",
    strokeWidth: 3.544,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M439.584 599.643C423.079 595.236 406 593.372 388.934 594.115",
    stroke: "#171717",
    strokeWidth: 3.544,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M528.316 823.778C516.551 796.952 495.053 775.573 468.83 762.52C442.689 749.615 412.914 746.059 384.468 752.445C384.068 752.527 383.677 752.622 383.275 752.716",
    stroke: "#171717",
    strokeWidth: 3.544,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M531.093 803.625C520.143 779.387 502.2 762.142 478.281 750.507C454.468 738.92 426.638 733.807 400.9 740.054L400.6 740.124",
    stroke: "#171717",
    strokeWidth: 3.544,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.579 753.7C347.71 719.126 297.367 700.781 248.429 704.821",
    stroke: "#171717",
    strokeWidth: 3.544,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.116 740.442C364.678 709.11 321.669 688.771 275.6 682.032C275.494 682.02 275.387 681.996 275.281 681.984",
    stroke: "#171717",
    strokeWidth: 3.544,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M702.864 848.441C684.449 861.611 666.03 874.782 647.607 887.953C640.662 892.926 625.007 903.321 629.676 913.845C634.519 924.745 649.076 918.57 656.276 914.554C660.682 912.097 665.073 909.612 669.447 907.1C688.253 896.34 706.786 885.118 725.047 873.436C749.853 857.596 774.112 840.945 797.822 823.483C821.41 806.119 844.633 787.775 863.249 765.143C867.064 760.512 870.868 754.512 868.718 748.913C866.781 743.869 860.509 741.636 855.169 742.522C849.829 743.408 845.224 746.645 840.83 749.787C794.833 782.672 748.844 815.557 702.864 848.441Z",
    stroke: "#171717",
    strokeWidth: 3.544,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M659.49 896.599C661.493 900.84 664.735 904.372 668.788 906.73C672.841 909.088 677.514 910.161 682.19 909.806C689.407 909.121 695.798 905.046 701.881 901.089L773.828 854.229",
    stroke: "#171717",
    strokeWidth: 3.544,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M724.4 872.42C724.281 866.509 722.042 860.837 718.092 856.438C714.142 852.039 708.742 849.205 702.878 848.453",
    stroke: "#171717",
    strokeWidth: 3.544,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M516.315 261.155C523.279 286.756 526.419 313.245 525.634 339.764",
    stroke: "#171717",
    strokeWidth: 3.544,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M791.842 284.386C760.762 288.086 732.142 307.216 715.829 333.928C699.516 360.64 695.485 394.279 703.878 424.433C707.884 438.833 714.856 452.814 726.161 462.585C737.466 472.356 753.585 477.292 767.84 472.808C782.095 468.324 792.992 453.184 790.283 438.488C789.497 434.222 787.692 430.209 785.022 426.79C782.352 423.371 778.896 420.647 774.948 418.85C771 417.052 766.677 416.235 762.345 416.467C758.013 416.699 753.802 417.973 750.068 420.182C736.068 428.466 732.468 448.029 737.301 463.565C742.134 479.101 753.318 491.69 763.701 504.212C774.084 516.734 784.314 530.493 786.53 546.612C788.746 562.731 779.952 581.483 764.021 584.788",
    stroke: "url(#paint10_linear_46_7733)",
    strokeWidth: 3.544,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.453 465.218C155.599 442.201 147.871 418.668 147.465 394.351C147.059 370.034 155.065 344.401 173.865 328.978C183.252 321.278 194.81 316.478 203.806 308.32C209.62 302.973 214.171 296.398 217.128 289.073C220.084 281.748 221.373 273.856 220.9 265.971C220.175 255.233 214.388 243.312 203.8 241.398C196.081 239.998 188.227 244.645 183.757 251.091C176.076 262.166 177.484 278.63 186.934 288.241C196.384 297.852 212.823 299.534 224.025 292.041C237.072 283.313 240.976 265.562 239.278 249.957C236.278 222.387 218.453 196.878 193.595 184.585",
    stroke: "url(#paint11_linear_46_7733)",
    strokeWidth: 3.544,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.799 432.365L215.816 407.328",
    stroke: "url(#paint12_linear_46_7733)",
    strokeWidth: 3.544,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.3 432.785C219.965 422.234 227.622 412.343 236.167 403.247",
    stroke: "url(#paint13_linear_46_7733)",
    strokeWidth: 3.544,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M463.805 62.5624L448.785 48.3994",
    stroke: "url(#paint14_linear_46_7733)",
    strokeWidth: 3.544,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M447.724 67.1697C452.642 58.1031 457.56 49.0364 462.478 39.9697",
    stroke: "url(#paint15_linear_46_7733)",
    strokeWidth: 3.544,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M774.977 168.278L766.639 155.772",
    stroke: "url(#paint16_linear_46_7733)",
    strokeWidth: 3.544,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M762.35 169.819L777.423 155.719",
    stroke: "url(#paint17_linear_46_7733)",
    strokeWidth: 3.544,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M643.9 348.517L631.433 332.642",
    stroke: "url(#paint18_linear_46_7733)",
    strokeWidth: 3.544,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M565.693 94.0708L584.871 55.7168",
    stroke: "#171717",
    strokeWidth: 3.544,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M574.866 104.91L591.542 100.74",
    stroke: "#171717",
    strokeWidth: 3.544,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M551.519 85.7327L544.849 61.5537",
    stroke: "#171717",
    strokeWidth: 3.544,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M757.467 389.235L776.645 370.057",
    stroke: "#171717",
    strokeWidth: 3.544,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M757.467 368.391L775.811 387.568",
    stroke: "#171717",
    strokeWidth: 3.544,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M662.415 594.349L687.428 435.927",
    stroke: "#171717",
    strokeWidth: 3.544,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M679.924 605.188L709.107 572.67",
    stroke: "#171717",
    strokeWidth: 3.544,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M636.565 590.178L625.728 545.988",
    stroke: "#171717",
    strokeWidth: 3.544,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M629.725 346.813L645.6 334.347",
    stroke: "url(#paint19_linear_46_7733)",
    strokeWidth: 3.544,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.489 162.266L311.794 159L303.048 170.78L310.575 183.375L296.668 178.699L287.016 189.749L287.166 175.077L273.674 169.312L287.674 164.921L288.987 150.307L297.489 162.266Z",
    fill: "#171717"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M626.094 190.106L638.111 196.365L624.911 199.423L622.673 212.788L615.685 201.179L602.283 203.18L611.165 192.946L605.12 180.818L617.597 186.103L627.263 176.607L626.094 190.106Z",
    stroke: "#171717",
    strokeWidth: 3.544,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M526.06 497.445C546.672 495.094 567.331 493.145 588.05 492.307C593.75 492.071 599.458 491.929 605.175 491.882C606.994 491.871 609.203 491.623 609.924 489.957C610.458 488.742 609.891 487.342 609.324 486.142C597.685 461.205 586.042 436.269 574.396 411.336V411.17C566.808 411.268 558.54 411.457 550.269 411.645C540.603 411.866 530.933 412.086 522.34 412.163L522.08 412.103C515.075 443.606 507.551 477.377 507.327 478.039C507.243 478.298 504.656 478.039 498.927 477.188C489.986 475.853 473.378 473.042 446.635 468.412C448.513 470.679 450.143 473.336 449.482 476.112C448.702 479.443 443.952 479.868 440.552 479.42C438.295 478.938 436.21 477.857 434.516 476.289L434.445 476.372C430.482 487.061 427.891 498.21 426.732 509.552C435.087 508.525 443.446 507.497 451.809 506.469C465.862 504.736 479.91 503.008 493.954 501.284C499.003 500.663 504.055 500.044 509.109 499.429C514.76 498.745 520.402 498.071 526.06 497.445ZM567.692 420.635C567.263 419.756 566.202 419.39 565.323 419.819C564.443 420.249 564.078 421.309 564.507 422.189C573.946 441.539 583.003 461.063 591.678 480.761C592.072 481.657 593.118 482.063 594.014 481.669C594.909 481.274 595.316 480.229 594.921 479.333C586.228 459.593 577.152 440.027 567.692 420.635Z",
    fill: "#171717"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M472.587 499.296L503.716 537.095",
    stroke: "#171717",
    strokeWidth: 1.181,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M452.576 504.854L499.268 572.669",
    stroke: "#171717",
    strokeWidth: 1.181,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M452.576 536.539L494.821 597.128",
    stroke: "#171717",
    strokeWidth: 1.181,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M448.684 575.45L483.705 623.81",
    stroke: "#171717",
    strokeWidth: 1.181,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437.568 609.913L465.917 649.379",
    stroke: "#171717",
    strokeWidth: 1.181,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420.892 626.033L450.909 663.276",
    stroke: "#171717",
    strokeWidth: 1.181,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.104 637.706L429.23 676.06",
    stroke: "#171717",
    strokeWidth: 1.181,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.98 644.377L403.659 682.176",
    stroke: "#171717",
    strokeWidth: 1.181,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.412 639.373L379.758 683.842",
    stroke: "#171717",
    strokeWidth: 1.181,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.286 620.474L356.412 678.84",
    stroke: "#171717",
    strokeWidth: 1.181,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.375 551.547L336.956 670.502",
    stroke: "#171717",
    strokeWidth: 1.181,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.367 553.215L311.386 650.491",
    stroke: "#171717",
    strokeWidth: 1.181,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M562.08 492.626L589.318 522.086",
    stroke: "#171717",
    strokeWidth: 1.181,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M535.956 489.846L592.097 555.994",
    stroke: "#171717",
    strokeWidth: 1.181,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M528.174 511.524L592.097 592.68",
    stroke: "#171717",
    strokeWidth: 1.181,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M532.064 551.547L590.985 627.7",
    stroke: "#171717",
    strokeWidth: 1.181,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M534.844 596.572L587.095 664.943",
    stroke: "#171717",
    strokeWidth: 1.181,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M537.066 634.927L584.871 693.848",
    stroke: "#171717",
    strokeWidth: 1.181,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M538.179 671.058L579.868 723.865",
    stroke: "#171717",
    strokeWidth: 1.181,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M536.511 702.742L574.866 754.437",
    stroke: "#171717",
    strokeWidth: 1.181,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M534.844 739.429L569.307 778.895",
    stroke: "#171717",
    strokeWidth: 1.181,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M570.975 484.844L531.508 542.653",
    stroke: "#171717",
    strokeWidth: 1.181,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M588.762 504.298L535.398 589.345",
    stroke: "#171717",
    strokeWidth: 1.181,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M590.986 554.326L537.624 628.812",
    stroke: "#171717",
    strokeWidth: 1.181,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M593.209 596.016L538.179 671.058",
    stroke: "#171717",
    strokeWidth: 1.181,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M590.985 645.487L537.066 718.305",
    stroke: "#171717",
    strokeWidth: 1.181,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M585.426 696.628L535.398 769.446",
    stroke: "#171717",
    strokeWidth: 1.181,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M480.925 498.74L450.352 575.449",
    stroke: "#171717",
    strokeWidth: 1.181,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M503.159 498.74L411.998 679.95",
    stroke: "#171717",
    strokeWidth: 1.181,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M501.908 548.906L436.456 671.891",
    stroke: "#171717",
    strokeWidth: 1.181,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.104 637.706L375.311 683.842",
    stroke: "#171717",
    strokeWidth: 1.181,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.643 644.932L349.741 676.617",
    stroke: "#171717",
    strokeWidth: 1.181,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.185 636.594L325.838 663.831",
    stroke: "#171717",
    strokeWidth: 1.181,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.395 616.027L309.718 650.49",
    stroke: "#171717",
    strokeWidth: 1.181,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.277 592.681L294.711 633.814",
    stroke: "#171717",
    strokeWidth: 1.181,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.718 572.67L283.594 613.804",
    stroke: "#171717",
    strokeWidth: 1.181,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.161 554.882L276.367 599.908",
    stroke: "#171717",
    strokeWidth: 1.181,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.14 576.561L288.596 552.659",
    stroke: "#171717",
    strokeWidth: 1.181,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M491.163 226.034C462.263 237.719 435.709 255.561 416.916 280.624C395.98 308.544 384.449 341.23 382.401 376.074C381.287 396.208 383.531 416.387 389.042 435.784C392.635 448.54 412.572 443.111 408.931 430.301C400.141 399.394 400.437 366.61 409.785 335.867C414.06 321.555 420.152 307.851 427.913 295.089C435.479 282.87 445.071 272.232 454.102 261.14C464.425 248.46 479.002 238.67 493.222 230.917C495.812 229.505 494.022 224.879 491.163 226.034V226.034Z",
    fill: "#171717"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M486.251 167.26C485.657 173.6 487.451 180.348 488.184 186.641C488.944 193.131 489.45 199.641 489.994 206.141C490.502 212.231 491.255 218.235 491.968 224.299C492.652 230.111 491.939 237.638 495.429 242.654C495.656 243.018 495.972 243.319 496.348 243.527C496.723 243.735 497.145 243.845 497.574 243.845C498.004 243.845 498.426 243.735 498.801 243.527C499.176 243.319 499.492 243.018 499.719 242.654C503.319 237.815 502.665 230.454 503.032 224.739C503.548 217.898 503.582 211.03 503.132 204.186C502.649 197.741 501.851 191.307 500.989 184.903C500.066 178.04 499.529 170.791 496.559 164.463C493.997 159.002 486.708 162.379 486.252 167.255L486.251 167.26Z",
    fill: "#171717"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M293.738 550.799C288.31 560.889 292.138 575.27 294.916 585.819C297.83 596.758 302.294 607.224 308.17 616.9C320.028 636.526 337.351 654.183 359.342 661.9C380.887 669.456 405.692 664.326 424.212 651.568C443.359 638.378 455.676 618.022 462.189 595.979C466.118 582.685 467.274 568.851 467.824 555.056C468.419 540.135 467.978 525.262 467.106 510.362C466.524 500.407 450.957 500.34 451.544 510.362C452.908 533.689 453.616 556.612 447.575 579.362C442.754 597.517 434.709 614.774 420.745 627.706C408.12 639.398 389.978 647.098 372.593 643.713C354.656 640.219 339.74 626.589 329.545 612.027C323.435 603.276 318.475 593.776 314.788 583.759C312.829 578.34 311.221 572.8 309.975 567.173C308.668 561.445 308.321 555.773 304.99 550.804C302.39 546.926 296.185 546.254 293.738 550.804V550.799Z",
    fill: "#171717"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M526.362 499.799C525.334 509.54 527.178 519.248 528.24 528.951C529.305 538.686 530.227 548.437 531.108 558.19C532.873 577.706 534.14 597.259 534.908 616.849C536.443 656.057 535.62 695.19 533.599 734.362C533.095 744.14 532.466 753.909 531.711 763.669C531.359 768.221 531.001 772.773 530.636 777.324C530.255 782.05 530.084 787.651 534.494 790.654C537.045 792.391 540.057 791.685 542.261 789.654C545.934 786.265 546.019 780.943 546.574 776.354C547.752 766.614 548.697 756.848 549.544 747.074C552.781 708 553.8 668.774 552.596 629.584C552.006 607.711 550.792 585.867 548.956 564.051C548.023 552.981 546.885 541.931 545.542 530.903C544.219 519.903 543.62 508.351 539.442 498.035C536.597 491.014 527.178 492.119 526.367 499.804L526.362 499.799Z",
    fill: "#171717"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_46_7733",
    x1: 786.103,
    y1: 742.332,
    x2: 786.103,
    y2: 873.436,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4A9FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2A67F7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_46_7733",
    x1: 429.864,
    y1: 243.236,
    x2: 429.864,
    y2: 441.615,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4A9FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2A67F7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_46_7733",
    x1: 639.991,
    y1: 169.486,
    x2: 639.991,
    y2: 299.691,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4A9FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2A67F7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_46_7733",
    x1: 676.936,
    y1: 848.441,
    x2: 676.936,
    y2: 919.969,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4A9FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2A67F7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_46_7733",
    x1: 529.192,
    y1: 226.486,
    x2: 529.192,
    y2: 264.367,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4A9FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2A67F7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_46_7733",
    x1: 524.622,
    y1: 222.838,
    x2: 524.622,
    y2: 283.032,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4A9FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2A67F7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_46_7733",
    x1: 550.441,
    y1: 260.481,
    x2: 550.441,
    y2: 412.161,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4A9FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2A67F7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_46_7733",
    x1: 497.623,
    y1: 222.839,
    x2: 497.623,
    y2: 341.348,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4A9FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2A67F7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_46_7733",
    x1: 496.699,
    y1: 222.589,
    x2: 496.699,
    y2: 288.005,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4A9FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2A67F7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_46_7733",
    x1: 434.786,
    y1: 747.578,
    x2: 434.786,
    y2: 918.416,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4A9FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2A67F7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_46_7733",
    x1: 745.731,
    y1: 284.386,
    x2: 745.731,
    y2: 584.788,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4A9FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2A67F7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_46_7733",
    x1: 193.551,
    y1: 184.585,
    x2: 193.551,
    y2: 465.218,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4A9FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2A67F7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_46_7733",
    x1: 225.808,
    y1: 407.328,
    x2: 225.808,
    y2: 432.365,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4A9FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2A67F7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_46_7733",
    x1: 224.733,
    y1: 403.247,
    x2: 224.733,
    y2: 432.785,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4A9FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2A67F7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_46_7733",
    x1: 456.295,
    y1: 48.3994,
    x2: 456.295,
    y2: 62.5624,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4A9FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2A67F7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_46_7733",
    x1: 455.101,
    y1: 39.9697,
    x2: 455.101,
    y2: 67.1697,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4A9FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2A67F7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_46_7733",
    x1: 770.808,
    y1: 155.772,
    x2: 770.808,
    y2: 168.278,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4A9FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2A67F7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_46_7733",
    x1: 769.886,
    y1: 155.719,
    x2: 769.886,
    y2: 169.819,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4A9FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2A67F7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_46_7733",
    x1: 637.666,
    y1: 332.642,
    x2: 637.666,
    y2: 348.517,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4A9FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2A67F7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_46_7733",
    x1: 637.662,
    y1: 334.347,
    x2: 637.662,
    y2: 346.813,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4A9FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2A67F7"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_46_7733"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 960,
    height: 960,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_46_7733"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 784,
    height: 884,
    fill: "white",
    transform: "translate(88 38)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStudentGoingToSchool);
export default __webpack_public_path__ + "static/media/student_going_to_school.352e2e453e7d0f5872be220e221dbd4a.svg";
export { ForwardRef as ReactComponent };